/* Wythout — floating Buy-now pill visibility.
   Shows the pill only while the shopper is BELOW the buy section, hides it at or
   above it (the real purchase UI is on screen there, so the pill would just
   cover its own destination).

   IntersectionObserver rather than a scroll handler: the browser does the
   geometry off the main thread and we get a callback only on the two crossings
   that matter, instead of running measurements on every scroll frame.

   The `boundingClientRect.bottom < 0` half is what makes it directional — "not
   intersecting" alone is true both above and below the section, and above it the
   pill must stay hidden. bottom < 0 means the section's lower edge has left the
   top of the viewport, i.e. we are past it. */
(function () {
  if (window.__wyBuyNowFab) return;
  window.__wyBuyNowFab = true;

  var VISIBLE = 'is-visible';
  var observers = [];

  function bind(fab) {
    var sel = fab.getAttribute('data-anchor');
    /* No anchor configured, or the anchor section isn't on this page (merchant
       deleted or disabled the buy band) — leave the pill hidden rather than
       pinning a CTA to every scroll position. */
    var anchor = sel ? document.querySelector(sel) : null;
    if (!anchor) return;

    /* No IntersectionObserver (very old browser): show it unconditionally. A
       always-on CTA is a lesser failure than a button that never appears. */
    if (!('IntersectionObserver' in window)) {
      fab.classList.add(VISIBLE);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        fab.classList.toggle(VISIBLE, past);
      });
    }, { threshold: 0 });

    io.observe(anchor);
    observers.push(io);
  }

  /* Theme Editor: either section can be re-rendered independently, which either
     replaces the pill or swaps the observed anchor node for a fresh one the old
     observer no longer knows about. Cheapest correct answer is to tear every
     observer down and re-bind from scratch. */
  function boot() {
    observers.forEach(function (io) { io.disconnect(); });
    observers = [];
    Array.prototype.forEach.call(document.querySelectorAll('.wy-fab'), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', boot);
})();
